module.exports = __webpack_public_path__ + "media/תוכי.028c360e.mp3";